module.exports = __webpack_public_path__ + "front/img/b40.474c4af0.jpg";